import React from 'react';
import PageHeader from '../components/ui/PageHeader';
import SafeIcon from '../common/SafeIcon';
import QuoteSection from '../components/quote/QuoteSection';
import { siteData } from '../data/content';
import * as FiIcons from 'react-icons/fi';

const { FiPhone } = FiIcons;

export default function Contact() {
  return (
    <div className="bg-slate-950">
      <PageHeader title="Get a Quote" subtitle="Ready to transform your vehicle? Fill out the form below or give us a call." />

      <div className="py-14 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-slate-900 border border-slate-800 flex items-center justify-center text-blue-500 rounded-sm flex-shrink-0">
                <SafeIcon name="Phone" className="text-xl" />
              </div>
              <div>
                <h4 className="text-white font-bold mb-1 uppercase text-xs tracking-wider">Call or Text</h4>
                <a href={`tel:${siteData.business.phoneTel}`} className="text-blue-400 hover:text-blue-300 font-bold transition-colors">
                  {siteData.business.phone}
                </a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-slate-900 border border-slate-800 flex items-center justify-center text-blue-500 rounded-sm flex-shrink-0">
                <SafeIcon name="Mail" className="text-xl" />
              </div>
              <div>
                <h4 className="text-white font-bold mb-1 uppercase text-xs tracking-wider">Email Us</h4>
                <p className="text-slate-400 text-sm">{siteData.business.email}</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-slate-900 border border-slate-800 flex items-center justify-center text-blue-500 rounded-sm flex-shrink-0">
                <SafeIcon name="MapPin" className="text-xl" />
              </div>
              <div>
                <h4 className="text-white font-bold mb-1 uppercase text-xs tracking-wider">Service Area</h4>
                <p className="text-slate-400 text-sm">{siteData.business.location} & Surrounding Areas</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <QuoteSection />
    </div>
  );
}